module.exports = __webpack_public_path__ + "img/jms.c117c9fd.png";